<template>
    <div class="header">
        <div class="content">
            <div class="header-logo">
                <img v-bind:src="model.headerLogoSource" v-bind:alt="model.headerLogoImgAlt" />
            </div>
            <div class="utility-actions">
                <router-link :to="{ name: 'logout' }" v-if="model.authenticated" class="utility-link utility-link--no-decoration" data-test-element="logout-link">logout</router-link>
            </div>
        </div>
    </div>
</template>

<script>
  import { routes } from '../routes'

  export default {
    data() {
      var regex = new RegExp(this.$appBase, "g");
      var tenantId = this.$hrefBase.replace(regex, '').replace(/\//g, '');
      return {
        routes,
        model: {
          authenticated: false, // TODO: Get the actual authentication state.
          headerLogoSource: this.$appBase + "images?key=headerLogo&tenantId=" + tenantId,
          headerLogoImgAlt: this.$t('shared:header:headerLogoImgAlt'),
        }
      }
    }
  }
</script>

<style>
</style>